import { Action } from 'redux';
import { ServiceCategoryState, ServiceCategoryUnloadState } from '../../states/ServiceCategoryState';
import { ServiceCategory } from '../../../models/Entities/ServiceCategory';

export default function ServiceCategoryBaseReducer(
  state: ServiceCategoryState | undefined,
  action: Action
): ServiceCategoryState {
  const currentState = state ?? ServiceCategoryUnloadState;
  const a: any = action;

  switch (a.type) {
    // GET ALL
    case 'SERVICE_CATEGORY_GET_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: false,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'SERVICE_CATEGORY_GET_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.ServiceCategories || []).map((incomingCategory: ServiceCategory) => {
              const existing = (currentState.list || []).find((sc: ServiceCategory) => sc.id === incomingCategory.id);
              return existing ? { ...existing, ...incomingCategory } : incomingCategory;
            })
          : a.ServiceCategories
      };
    case 'SERVICE_CATEGORY_GET_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error
      };

    // UPDATE ALL
    case 'SERVICE_CATEGORY_UPDATE_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingAll: true,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: false,
        error: undefined
      };
    case 'SERVICE_CATEGORY_UPDATE_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: true,
        FailUpdatingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.ServiceCategories || []).map((incomingCategory: ServiceCategory) => {
              const existing = (currentState.list || []).find((sc: ServiceCategory) => sc.id === incomingCategory.id);
              return existing ? { ...existing, ...incomingCategory } : incomingCategory;
            })
          : a.ServiceCategories
      };
    case 'SERVICE_CATEGORY_UPDATE_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: true,
        error: a.error
      };

    // GET BY ID
    case 'SERVICE_CATEGORY_GET_BY_ID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingOne: true,
        successLoadingOne: false,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'SERVICE_CATEGORY_GET_BY_ID_RECEIVE_ACTION': {
      const CurrentCategory = (currentState.list || []).find((item: ServiceCategory) => item.id === a.ServiceCategory.id);
      const updatedCategory = CurrentCategory ? { ...CurrentCategory, ...a.ServiceCategory } : a.ServiceCategory;
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: true,
        failOnLoadingOne: false,
        error: undefined,
        list: CurrentCategory
          ? [...(currentState.list || []).filter((item: ServiceCategory) => item.id !== a.ServiceCategory.id), updatedCategory]
          : [...(currentState.list || []), a.ServiceCategory]
      };
    }
    case 'SERVICE_CATEGORY_GET_BY_ID_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: false,
        failOnLoadingOne: true,
        error: a.error
      };

    // ADD
    case 'SERVICE_CATEGORY_ADD_REQUEST_ACTION':
      return {
        ...currentState,
        isAdding: true,
        isAddingSuccess: undefined,
        failOnAdding: false,
        isSavingSuccess: undefined,
        isDeletingSuccess: undefined,
        error: undefined
      };
    case 'SERVICE_CATEGORY_ADD_RECEIVE_ACTION':
      return {
        ...currentState,
        isAdding: false,
        isAddingSuccess: true,
        failOnAdding: false,
        error: undefined,
        list: [...(currentState.list || []), a.ServiceCategory]
      };
    case 'SERVICE_CATEGORY_ADD_FAIL_ACTION':
      return {
        ...currentState,
        isAdding: false,
        isAddingSuccess: false,
        failOnAdding: true,
        error: a.error
      };

    // UPDATE
    case 'SERVICE_CATEGORY_UPDATE_REQUEST_ACTION':
      return {
        ...currentState,
        isSaving: true,
        isSavingSuccess: undefined,
        failOnSaving: false,
        isAddingSuccess: undefined,
        isDeletingSuccess: undefined,
        error: undefined
      };
    case 'SERVICE_CATEGORY_UPDATE_RECEIVE_ACTION':
      return {
        ...currentState,
        isSaving: false,
        isSavingSuccess: true,
        failOnSaving: false,
        error: undefined,
        list: [...(currentState.list || []).filter((item: ServiceCategory) => item.id !== a.ServiceCategory.id), a.ServiceCategory]
      };
    case 'SERVICE_CATEGORY_UPDATE_FAIL_ACTION':
      return {
        ...currentState,
        isSaving: false,
        isSavingSuccess: false,
        failOnSaving: true,
        error: a.error
      };

    // DELETE
    case 'SERVICE_CATEGORY_DELETE_REQUEST_ACTION':
      return {
        ...currentState,
        isDeleting: true,
        isDeletingSuccess: undefined,
        failOnDeleting: false,
        isAddingSuccess: undefined,
        isSavingSuccess: undefined,
        error: undefined
      };
    case 'SERVICE_CATEGORY_DELETE_RECEIVE_ACTION':
      return {
        ...currentState,
        isDeleting: false,
        isDeletingSuccess: true,
        failOnDeleting: false,
        error: undefined,
        list: (currentState.list || []).filter((item: ServiceCategory) => item.id !== a.ServiceCategoryId)
      };
    case 'SERVICE_CATEGORY_DELETE_FAIL_ACTION':
      return {
        ...currentState,
        isDeleting: false,
        isDeletingSuccess: false,
        failOnDeleting: true,
        error: a.error
      };

    default:
      return currentState;
  }
}
